import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import SelectAccessTypePopup from './popups/SelectAccessTypePopup'
import useAccessParams from '../hooks/useAccessParams'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import AccessSettings from './AccessSettings'
import { useHistory } from 'react-router-dom'
import { forwardRef, Fragment } from 'react'
import { useReduxSelector } from 'store'
import { toDateTime } from 'utils/date'
import Error from 'components/Error'

interface MagAccessListProps {
  full?: boolean
  more?: basic.BasicFunc
}

const MagAccessList = forwardRef<HTMLDivElement, MagAccessListProps>(({ full, more }, ref) => {
  const { id, type } = useAccessParams()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const { popup, openPopup } = usePopupState()

  const { t, lang } = useTranslation('account')
  const { push, replace } = useHistory()

  return (
    <>
      {popup === 'addAccess' && <SelectAccessTypePopup
        selectType={selectedType => {
          replace(`/warehouses/${id}/${type}/${selectedType}`)
        }}
      />}
      <div className='menu__section'>
        {warehouse['2fa_access'] && full && <AccessSettings />}

        <div className='group'>
          <p>{t('manageAccess')}</p>
          <div
            className='menu__more --secFont'
            onClick={() => {
              openPopup('addAccess')
            }}>{t('new')} →</div>
        </div>

        <div
          ref={ref}
          className='menu__access'>
          <hr />
          {warehouse?.sharing
            ?.filter((_, i) => full ? true : i < 3)
            ?.map(({ id: permissionId, validUntil, userName, oneTime, isActive, disabled, functions }) => {
              const type = oneTime ? 'one-time-access' : validUntil ? 'time-access' : 'permanent-access'
              return <Fragment key={permissionId}>
                <div
                  className='access__item'
                  style={(!isActive || disabled) ? { opacity: 0.5 } : undefined}
                  onClick={() => {
                    push(`/warehouses/${id}/access/${type}/${permissionId}`)
                  }}>
                  <div className='center'>
                    <i className={`icon icon--${oneTime ? 'oneTimeAccess' : validUntil ? 'clock' : 'infinity'} ${type === 'permanent-access' ? 's24' : 's32'}`} />
                  </div>
                  <div className='access__desc'>
                    <div className='--secFont'>{userName}</div>
                    <div>
                      <span>{t(type)}</span>
                      {validUntil && <span>: {toDateTime(validUntil, lang)}</span>}
                    </div>
                    {functions && functions.length > 0 && <div>{functions.map((f, i) => `${i ? ', ' : ''}${t(f)}`)}</div>}
                    {disabled && <div>{t('temporaryDeactivationOfAccess')}</div>}
                  </div>
                  <div className='access__symbol center'>
                    <i className='icon icon--arrow-right' />
                  </div>
                </div>
                <hr />
              </Fragment>
            })}

          {(!warehouse?.sharing || warehouse.sharing.length === 0) && <Error
            staticPos={!full || !!warehouse['2fa_access']}
            text={t('noItem')}
          />}

          {!full && <>
            <div
              className='menu__more center --secFont --high'
              onClick={more}>{t('more')} →</div>
            <hr />
          </>}
        </div>
      </div>
    </>
  )
})

export default MagAccessList